__turbopack_context__.v({
  "collapseSection": "LanguageSwitcher-module__HW8kdG__collapseSection",
  "icon-chevron-right": "LanguageSwitcher-module__HW8kdG__icon-chevron-right",
  "languageSwitcherButton": "LanguageSwitcher-module__HW8kdG__languageSwitcherButton",
  "languageSwitcherList": "LanguageSwitcher-module__HW8kdG__languageSwitcherList",
  "languageSwitcherListContainer": "LanguageSwitcher-module__HW8kdG__languageSwitcherListContainer",
  "languageSwitcherListElement": "LanguageSwitcher-module__HW8kdG__languageSwitcherListElement",
});
